'use client';

import { PasswordInput, type PasswordInputProps } from '@components/ui';
import type { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import { Field, type FieldProps } from './field';

interface FormPasswordInputProps
  extends PasswordInputProps, Omit<FieldProps, keyof PasswordInputProps> {
  label: string;
  id: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  errors: FieldErrors;
}

const FormPasswordInput = ({
  label,
  id,
  register,
  control,
  errors,
  disabled,
  helperText,
  isShowLabel = true,
  disableLabel = false,
  labelProps,
  required = false,
  ...rest
}: FormPasswordInputProps) => {
  return (
    <Field
      label={label}
      invalid={!!errors?.[id]}
      id={id}
      errorText={errors?.[id]?.message as string}
      helperText={helperText}
      disabled={disabled}
      isShowLabel={isShowLabel}
      disableLabel={disableLabel}
      labelProps={labelProps}
      required={required}
    >
      <PasswordInput
        {...rest}
        id={id}
        {...register(id)}
        name={id}
        placeholder={`Enter ${label || id}`}
        disabled={disabled}
      />
    </Field>
  );
};

export default FormPasswordInput;
